<template>
  <vue-modal name="InfoTask" :hideCloseBtn="true" :width="width">
    <!-- :on-show="changeForm()" -->

    <modalImg ref="imgzoomC2" :name="'modalImg2'" :arrImg="modalArr" />

    <div class="card" style="border: none">
      <div class="card-header" style="border-bottom: none; padding: 1rem 0px">
        <h3 class="form-section">
          <i class="icon-info"></i>
          {{ $t("tasks.titles.details") + " " + dataTask.docNumber }}
          <span
            v-if="dataTask.priority != null"
            class="tag"
            :class="
              'tag-' + $t('priority.statuses.' + dataTask.priority + '.class')
            "
          >
            {{ $t("priority.statuses." + dataTask.priority + ".word") }}
          </span>
        </h3>
        <div class="heading-elements" style="right: 0px">
          <button
            type="button"
            class="btn btn-warning"
            @click="
              clearData();
              $modals.hide('InfoTask');
            "
          >
            <i style="color: #ffffff" class="icon-cross"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex flex-row mb-1" v-if="dataTask.msp_id">
          <button type="button" class="btn btn-success" @click="clickMSPTask">
            {{ $t("tasks.titles.openExtTask") }}
          </button>
        </div>

        <ul class="nav nav-tabs mb-1">
          <li class="nav-item">
            <a
              class="nav-link"
              v-bind:class="{ active: dataTask.tabs.info }"
              id="base-tab1"
              data-toggle="tab"
              @click="dataTask.tabs.info = true"
            >
              <i class="icon-info"></i>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              v-bind:class="{ active: dataTask.tabs.photo }"
              id="base-tab2"
              data-toggle="tab"
              @click="dataTask.tabs.photo = true"
            >
              <i class="icon-images2"></i>
            </a>
          </li>
          <!-- <li class="nav-item">
                        <a class="nav-link" v-bind:class="{'active': dataTask.tabs.files }" id="base-tab3" data-toggle="tab" @click="dataTask.tabs.files = true">
                            <i class="icon-file-text2"></i>
                        </a>
                    </li> -->
          <li class="nav-item">
            <a
              class="nav-link"
              v-bind:class="{ active: dataTask.tabs.history }"
              id="base-tab4"
              data-toggle="tab"
              @click="dataTask.tabs.history = true"
            >
              <i class="icon-history"></i>
            </a>
          </li>
        </ul>
        <div class="row" v-show="showinfo">
          <div class="col-md-12">
            <div class="row" v-if="dataTask.tabs.info">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="typeTask">{{ $t("tasks.table.type") }}</label>
                  <div class="position-relative has-icon-left">
                    <input
                      type="text"
                      id="typeTask"
                      class="form-control border-primary"
                      name="typeTask"
                      :value="$t(dataTask.WorkType)"
                      disabled
                    />
                    <div class="form-control-position">
                      <i class="icon-clipboard2"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="typeTask">{{
                    $t("equipm.table.location")
                  }}</label>
                  <div class="position-relative has-icon-left">
                    <input
                      type="text"
                      id="address"
                      name="address"
                      class="form-control border-primary"
                      v-model="dataTask.address"
                      disabled
                    />
                    <div class="form-control-position">
                      <i class="icon-location-arrow"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="dataTask.tabs.info">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="organiz">{{
                    $t("registr.lbl.organization")
                  }}</label>
                  <div class="position-relative has-icon-left">
                    <input
                      type="text"
                      id="organiz"
                      name="organiz"
                      class="form-control border-primary"
                      v-model="dataTask.organization"
                      disabled
                    />
                    <div class="form-control-position">
                      <i class="icon-office"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="execPers">{{ $t("tasks.table.execPers") }}</label>
                  <div class="position-relative has-icon-left">
                    <input
                      type="text"
                      id="execPers"
                      name="execPers"
                      class="form-control border-primary"
                      :value="dataTask.execPers"
                      disabled
                    />
                    <div class="form-control-position">
                      <i class="icon-user"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="dataTask.tabs.info">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="contPers">{{ $t("tasks.table.contPers") }}</label>
                  <div class="position-relative has-icon-left">
                    <input
                      type="text"
                      id="contPers"
                      name="contPers"
                      class="form-control border-primary"
                      :value="dataTask.contPers"
                      disabled
                    />
                    <div class="form-control-position">
                      <i class="icon-user"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="jobss">{{ $t("tasks.table.jobs") }}</label>
                  <div class="position-relative has-icon-left">
                    <div class="form-control-position">
                      <i class="icon-clipboard2"></i>
                    </div>
                    <!-- <textarea id="jobss" name="jobss" rows="2" class="form-control border-primary" v-model="dataTask.jobs" disabled></textarea> -->
                    <div
                      class="form-control border-primary"
                      style="background-color: #eceeef; min-height: 2em"
                    >
                      {{ dataTask.jobs }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="dataTask.tabs.info">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="form-group mb-0">
                    <label for="comment">{{ $t("tasks.table.comment") }}</label>
                    <div class="position-relative has-icon-left">
                      <div class="form-control-position">
                        <i class="icon-file-text"></i>
                      </div>
                      <textarea
                        id="comment"
                        name="comment"
                        rows="4"
                        class="form-control border-primary"
                        v-model="dataTask.comment"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- список проблемних категорій -->
            <div class="row mb-1" v-if="dataTask.problemsList.length > 0">
              <div class="col-md-8 offset-md-2">
                <div class="mobileTbl table-responsive">
                  <table class="table table-hover mb-0" cellspacing="0">
                    <thead>
                      <tr>
                        <th
                          class="text-truncate"
                          style="vertical-align: middle"
                        ></th>
                        <th
                          class="text-truncate"
                          style="vertical-align: middle"
                        >
                          {{ $t("equipm.table.nameEq") }}
                        </th>
                        <th
                          class="text-truncate"
                          style="vertical-align: middle"
                        >
                          {{ $t("tasks.table.comment") }}
                        </th>
                        <th
                          class="text-truncate"
                          style="vertical-align: middle"
                        ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in dataTask.problemsList"
                        :key="index"
                      >
                        <!--paginatedData listTasks-->
                        <td class="text-truncate" data-title="">
                          <i class="font-large-1" :class="item.class"></i>
                        </td>
                        <td
                          class="text-truncate"
                          :data-title="$t('equipm.table.nameEq')"
                        >
                          <span>{{ item.title }}</span>
                        </td>
                        <td
                          class="text-truncate"
                          :data-title="$t('tasks.table.comment')"
                        >
                          <span>{{ item.comment }}</span>
                        </td>
                        <td class="text-truncate">
                          <!-- <div class="row" style="float: right; margin-right: 5px">
                                                        <div class="btn-group">
                                                            <button type="button" class="btn btn-success" >
                                                                <i class="icon-play4"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger">
                                                                <i class="icon-stop3"></i>
                                                            </button>
                                                        </div>
                                                    </div> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- список проблемних категорій -->

            <ul class="nav nav-tabs mt-1" v-if="dataTask.tabs.info">
              <li class="nav-item">
                <a
                  class="nav-link"
                  v-bind:class="{ active: dataTask.tabs.equipm }"
                  id="base-tab5"
                  data-toggle="tab"
                  @click="dataTask.tabs.equipm = true"
                >
                  <i class="icon-menu"></i>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  v-bind:class="{ active: dataTask.tabs.change }"
                  id="base-tab6"
                  data-toggle="tab"
                  @click="dataTask.tabs.change = true"
                >
                  <i class="icon-loop22"></i>
                </a>
              </li>
            </ul>

            <div class="row" v-if="dataTask.tabs.info && dataTask.tabs.equipm">
              <div class="col-md-12">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-eye6"></i> {{ $t("titles.equipment") }}
                  </h4>
                </form>
                <div
                  class="mobileTbl table-responsive"
                  v-if="dataTask.equipment.length > 0"
                >
                  <table class="table table-hover mb-0" cellspacing="0">
                    <thead>
                      <tr>
                        <th style="vertical-align: middle">
                          {{ $t("equipm.table.nameEq") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("equipm.table.serNumber") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("equipm.table.location") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("equipm.table.actDt") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("equipm.table.guarantee") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="(eq, index) in dataTask.equipment"
                      :key="index"
                    >
                      <tr
                        @click="showModalEqinfo($event, eq.serial)"
                        class="hand"
                      >
                        <td :data-title="$t('equipm.table.nameEq')">
                          <span>{{ eq.name }}</span>
                        </td>
                        <td
                          :data-title="$t('equipm.table.serNumber')"
                          class="text-truncate"
                        >
                          <span>{{ eq.serial }}</span>
                        </td>
                        <td :data-title="$t('equipm.table.location')" class="">
                          <a
                            v-if="eq.city.length > 5"
                            class=""
                            @click="
                              showModalMap(
                                $event,
                                eq.city,
                                eq.name + ' (' + eq.serial + ')'
                              )
                            "
                            >{{ eq.city }} <i class="icon icon-location2"></i
                          ></a>
                          <span v-else>{{ eq.city }}</span>
                        </td>
                        <td
                          :data-title="$t('equipm.table.actDt')"
                          class="text-truncate"
                        >
                          <span>{{ eq.actDt }}</span>
                        </td>
                        <td
                          :data-title="$t('equipm.table.guarantee')"
                          class="text-truncate"
                        >
                          <div v-if="eq.guarantee" class="tag tag-success">
                            {{ $t("equipm.table.guarantee") }}
                          </div>
                          <div v-if="!eq.guarantee" class="tag tag-danger">
                            {{ $t("equipm.table.noGuar") }}
                          </div>
                        </td>
                      </tr>
                      <tr v-if="eq.history.length > 0" class="marginTR">
                        <td></td>
                        <td :colspan="5" class="paddingTD">
                          <span style="font-size: 0.8em">{{ eq.history }}</span>
                        </td>
                        <!-- <table class="childTable table table-hover mb-0">
                                                            <thead><tr><th scope="col">Task</th><th scope="col">Status</th></tr></thead>
                                                            <tbody v-for="(action,ind) in eq.history" :key="ind"><tr>
                                                                <td data-title="Task" scope="row">{{action.task}}</td>
                                                                <td data-title="Status">{{action.status}}</td>
                                                            </tr></tbody>
                                                        </table> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row" v-if="dataTask.tabs.info && dataTask.tabs.change">
              <div class="col-md-12">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-loop22"></i> {{ $t("titles.changesComp") }}
                  </h4>
                </form>

                <div class="row">
                  <div class="col-md-12">
                    <div class="mobileTbl table-responsive">
                      <table class="table table-hover mb-0" cellspacing="0">
                        <thead>
                          <tr>
                            <th
                              class="text-truncate"
                              style="vertical-align: middle"
                            ></th>
                            <th
                              class="text-truncate"
                              style="vertical-align: middle"
                            >
                              {{ $t("equipm.table.nameEq") }}
                            </th>
                            <th
                              class="text-truncate"
                              style="vertical-align: middle"
                            >
                              {{ $t("problem.table.chFrom") }}
                            </th>
                            <th
                              class="text-truncate"
                              style="vertical-align: middle"
                            >
                              {{ $t("problem.table.chTo") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(ch, index) in dataTask.changesList"
                            :key="index"
                          >
                            <td>
                              <i :class="ch.class"></i>
                              <span>{{ $t(ch.title) }}</span>
                            </td>
                            <td :data-title="$t('equipm.table.nameEq')">
                              <span>{{ ch.nameEq }}</span>
                            </td>
                            <td :data-title="$t('problem.table.chFrom')">
                              <span>{{ ch.from }}</span>
                            </td>
                            <td :data-title="$t('problem.table.chTo')">
                              <span>{{ ch.to }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- foto -->
            <div v-if="dataTask.tabs.photo">
              <form class="form">
                <h4 class="form-section">
                  <i class="icon-images2"></i> {{ $t("tasks.table.images") }}
                </h4>
              </form>

              <div class="row" v-if="dataTask.taskPict.length > 0">
                <div class="col-md-12" style="display: flex; flex-wrap: wrap">
                  <div
                    class="col-xs-3"
                    style="
                      padding: 0;
                      display: flex;
                      flex-direction: column;
                      align-content: center;
                      justify-content: center;
                      margin-bottom: 1em;
                    "
                    v-for="(image, index) in dataTask.taskPict"
                    :key="index"
                  >
                    <div class="card hand mb-0" style="margin-left: 5px">
                      <div class="w-100 h-100 d-flex justify-content-center">
                        <img
                          v-bind:src="image"
                          style="max-width: 100%; max-height: 100%"
                          @click="expandDiv(dataTask.taskPict, index)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row" v-if="dataTask.taskPict.length < dataTask.countPhoto">
                                <div class="col-md-12">
                                    <form class="form-body">
                                        <div class="form-actions center mt-0 mb-0" style="padding: 0;">
                                            <button type="button" class="btn btn-secondary" @click="loadPictures()"><i class="icon-download"></i> {{dataTask.taskPict.length + ' / ' + dataTask.countPhoto}}</button>
                                        </div>
                                    </form>
                                </div>
                            </div> -->
            </div>
            <!-- foto -->

            <!-- history -->
            <div class="col-md-12" v-if="dataTask.tabs.history">
              <form class="form">
                <h4 class="form-section">
                  <i class="icon-history"></i> {{ $t("titles.history") }}
                </h4>
              </form>
              <div
                class="mobileTbl table-responsive"
                v-if="dataTask.history.length > 0"
              >
                <table class="table table-hover mb-0" cellspacing="0">
                  <thead>
                    <tr>
                      <!-- <th style="vertical-align: middle;">{{ $t('tasks.table.docNumb') }}</th> -->
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.status") }}
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.date") }}
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.rspnsbl") }}
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.elapsedTime") }}
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.comment") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(el, index) in dataTask.history" :key="index">
                      <!-- guid -->
                      <!-- <td :data-title="$t('tasks.table.docNumb')">
                                                <span>{{el.docNumber}}</span>
                                            </td> -->
                      <td :data-title="$t('tasks.table.status')">
                        <span
                          class="tag"
                          :class="'tag-' + $t(el.stage + '.class')"
                          >{{ $t(el.stage + ".title") }}</span
                        >
                      </td>
                      <td :data-title="$t('tasks.table.date')">
                        <span>{{ el.date }}</span>
                      </td>
                      <td :data-title="$t('tasks.table.rspnsbl')">
                        <span>{{ el.responsible }}</span>
                      </td>
                      <td :data-title="$t('tasks.table.elapsedTime')">
                        <span>{{ el.spentTime }} {{ $t("meas.min") }}</span>
                      </td>
                      <td :data-title="$t('tasks.table.comment')">
                        <span>{{ el.comment }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- history -->
          </div>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
export default {
  name: "ModalTaskInfo",
  data() {
    return {
      showinfo: false,
      width: null,
      dataTask: {
        GUID: null,
        status: null, //value for show status
        statusTXT: null, //text value for variant
        statusBP: null,

        WorkType: null, //type task
        typeName: null, //title name type of task
        docNumber: null,
        organization: null,
        execPers: null,
        contPers: null,
        address: null,
        addressT: {
          country: null,
          region: null,
          city: null,
          street: null,
          index: null,
        },
        comment: null,
        jobs: null,

        countLoad: 3,
        countPhoto: 0,
        taskPict: [],

        fileReport: { name: "", data: null },
        equipment: [],
        history: [],
        sumHistory: null,

        reasonComment: null,
        priority: null,
        tabs: {
          info: true,
          photo: false,
          files: false,
          history: false,

          equipm: true,
          change: false,
        },

        problemsList: [],
        categories: [],
      },
      modalArr: [],

      //coords
      position: {
        latitude: null,
        longitude: null,
        accuracy: null,
      },
    };
  },
  components: {},
  props: {},
  methods: {
    changeForm() {
      //document.getElementsByClassName('v-modal__heading').style.padding = '0px';
      /*setTimeout( () => {
                    $('.v-modal__heading').css({"padding":"0px"});
                },500 
            );*/
    },
    clearData() {
      this.dataTask.GUID = null;
      this.dataTask.status = null; //string
      this.dataTask.statusBP = null; //number
      this.dataTask.statusTXT = null; //string need!
      this.dataTask.variant = null;

      this.dataTask.WorkType = null;
      this.dataTask.typeName = null;
      this.dataTask.docNumber = null; //номер документа
      this.dataTask.organization = null;
      this.dataTask.execPers = null;
      this.dataTask.contPers = null;

      this.dataTask.address = null;

      this.dataTask.addressT.country = null;
      this.dataTask.addressT.region = null;
      this.dataTask.addressT.city = null;
      this.dataTask.addressT.street = null;
      this.dataTask.addressT.streetN = null;
      this.dataTask.addressT.index = null;

      this.dataTask.comment = null;
      this.dataTask.jobs = null;
      this.dataTask.taskPict = [];
      this.dataTask.fileReport = { name: "", data: null };
      this.dataTask.equipment = [];
      this.dataTask.history = [];
      this.dataTask.sumHistory = null;

      this.dataTask.reasonComment = null;
      this.dataTask.priority = null;

      this.dataTask.tabs.info = true;
      this.dataTask.tabs.photo = false;
      this.dataTask.tabs.files = false;
      this.dataTask.tabs.history = false;

      this.dataTask.tabs.equipm = true;
      this.dataTask.tabs.change = false;

      this.dataTask.problemsList = [];
      this.dataTask.categories = [];
    },
    getTaskInfo(guidTask) {
      this.clearData();

      let dataRequest = {
        guidTask: guidTask,
        quantityStart: 0,
        quantityFinish: 0,
      };

      this.makeQuery("/service/getinfotask", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null) {
            if (result.DocNumber != undefined) {
              this.dataTask.msp_id = result.msp_id ? result.msp_id : null;
              this.dataTask.GUID = guidTask;
              this.dataTask.execPers = result.Assignee;
              this.dataTask.docNumber = result.DocNumber;

              for (let i = 0; i < this.$store.state.typesTask.length; i++) {
                if (result.WorkType == this.$store.state.typesTask[i].val) {
                  this.dataTask.WorkType = this.$store.state.typesTask[i].text; //тип заявки
                }
              }
              //this.dataTask.typeName = ;

              this.dataTask.address = result.Adress;
              if (
                result.AdressSructure != undefined &&
                result.AdressSructure != null
              ) {
                this.dataTask.addressT.country = result.AdressSructure.Country;
                this.dataTask.addressT.region = result.AdressSructure.Region;
                this.dataTask.addressT.city = result.AdressSructure.Location;
                this.dataTask.addressT.street = result.AdressSructure.Street;
                this.dataTask.addressT.streetN = result.AdressSructure.StreetN;
                this.dataTask.addressT.index = result.AdressSructure.PostalCode;
              }

              this.dataTask.organization = result.Organization;
              this.dataTask.status = result.Status;
              this.dataTask.statusTXT = result.Status;

              /*if((result.Files != undefined) && (result.Files.length > 0)){
                            for (let i = 0; i < result.Files.length; i++) {
                                this.dataTask.taskPict.push({
                                    name: result.Files[i].name,
                                    data: 'data:image/jpg;base64,' + result.Files[i].data,
                                });
                            }
                        }*/

              // if(result.quantityPhoto != undefined){
              //     this.dataTask.countPhoto = result.quantityPhoto;
              //     this.loadPictures();
              // }

              this.dataTask.jobs = result.WorkList;
              this.dataTask.comment = result.Comment;
              this.dataTask.contPers = result.ClientInfo;

              let el;
              for (let i = 0; i < result.ArrayGoods.length; i++) {
                el = result.ArrayGoods[i];

                let guarant = false;
                if (el.ActivationDate) {
                  guarant = this.getGuarrantee(el.ActivationDate);
                  el.ActivationDate = this.dtFormat(el.ActivationDate);
                } else {
                  guarant = el.Guarantee;
                }

                if (el.WorkList == undefined) {
                  el.WorkList = null;
                }

                this.dataTask.equipment.push({
                  name: el.Goods,
                  serial: el.SN,
                  article: el.Articule,
                  dtManuf: this.dtFormat(el.ProductionDate),
                  guarantee: guarant,
                  city: el.City,
                  actDt: el.ActivationDate,
                  history: el.WorkList,
                });
              }

              if (result.Priority == undefined || result.Priority == null) {
                this.dataTask.priority = null;
              } else {
                this.dataTask.priority = result.Priority;
              }

              /*if((result.ArrayProblemEquipment != undefined) && (result.ArrayProblemEquipment.length > 0)){
                            this.dataTask.problemsList = [];

                            for (let i = 0; i < result.ArrayProblemEquipment.length; i++) {
                                for (let j = 0; j < this.$store.state.categories.length; j++){
                                    if(this.$store.state.categories[j].id == parseFloat(result.ArrayProblemEquipment[i].icon)){
                                        this.dataTask.problemsList.push({
                                            id: this.$store.state.categories[j].id,
                                            guid: result.ArrayProblemEquipment[i].guid,
                                            title: result.ArrayProblemEquipment[i].name,
                                            class: this.$store.state.categories[j].class,
                                            comment: result.ArrayProblemEquipment[i].comment
                                        });
                                        break
                                    }   
                                }
                            }
                        }*/

              this.showinfo = true;

              $(".v-modal__heading").css({ padding: "0px" });
            } else {
              this.showinfo = false;
              this.showNotification("custom-info", "Task", "No information");
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    loadPictures() {
      if (this.dataTask.taskPict.length < 1) {
        let dataRequest = { guidTask: this.dataTask.GUID };
        this.makeQuery2("/service/getImageTask", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            let arr_img = [],
              mark_old = false;

            if (
              result &&
              result.data &&
              result.data.signed_urls &&
              Array.isArray(result.data.signed_urls)
            ) {
              arr_img = result.data.signed_urls;
            }
            if (
              result &&
              result.data &&
              result.data.data &&
              Array.isArray(result.data.data)
            ) {
              arr_img = result.data.data;
              mark_old = true;
            }
            if (arr_img.length) {
              for (let i = 0; i < arr_img.length; i++) {
                if (mark_old) {
                  this.dataTask.taskPict.push(arr_img[i] + "/preview");
                } else {
                  this.dataTask.taskPict.push(arr_img[i].url);
                }
              }
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    loadHistory() {
      let mins = null;
      if (this.dataTask.history.length < 1) {
        this.dataTask.history = [];
        let dataRequest = { guidTask: this.dataTask.GUID };
        this.makeQuery("/service/getHistoryWork", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            this.dataTask.history = [];
            this.dataTask.history = result;

            this.dataTask.sumHistory = 0;

            for (let i = 0; i < this.dataTask.history.length; i++) {
              this.dataTask.history[i].date = this.dtFormat(
                this.dataTask.history[i].date
              );

              mins = this.dataTask.history[i].spentTime;
              if (typeof mins == "string" && mins.indexOf(",") > -1) {
                mins = mins.replace(",", ".");
                mins = parseFloat(mins);
              }
              this.dataTask.history[i].spentTime = Math.ceil(mins);

              this.dataTask.sumHistory =
                this.dataTask.sumHistory + this.dataTask.history[i].spentTime;

              switch (this.dataTask.history[i].stage) {
                case 0:
                  this.dataTask.history[i].stage = "history.statuses.new";
                  break;
                case 1:
                  this.dataTask.history[i].stage = "history.statuses.agreed";
                  break;
                case 2:
                  this.dataTask.history[i].stage = "history.statuses.process";
                  break;
                case 3:
                  this.dataTask.history[i].stage = "history.statuses.finish";
                  break;
                case 4:
                  this.dataTask.history[i].stage = "history.statuses.done";
                  break;
                case 5:
                  this.dataTask.history[i].stage = "history.statuses.cancel";
                  break;
                case 7:
                  this.dataTask.history[i].stage = "tasks.statuses.bring";
                  break;
              }
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    sendReport() {
      let dataRequest = {
        guidTask: this.dataTask.GUID,
      };
      this.makeQuery("/service/printprotokol", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (
            (result.data != undefined || result.data != null) &&
            result.name != this.dataTask.fileReport.name
          ) {
            this.dataTask.fileReport.name = result.name;
            this.dataTask.fileReport.data = this.base64String(
              result.name,
              result.data
            );
          }

          if (this.dataTask.fileReport.data != null) {
            fileDownload(
              this.dataTask.fileReport.data,
              this.dataTask.fileReport.name
            );
          } else {
            this.showNotification(
              "custom-info",
              "File empty",
              this.dataTask.fileReport.name + ", contact Modern ASU!"
            );
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    base64String(file, data) {
      let mediatype = "";

      const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };

      if (file.indexOf(".xlsx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (file.indexOf(".xls") > -1) {
        mediatype = "application/vnd.ms-excel";
      } else if (file.indexOf(".txt") > -1) {
        mediatype = "text/plain";
      } else if (file.indexOf(".xml") > -1) {
        mediatype = "text/xml";
      } else if (
        file.indexOf(".png") > -1 ||
        file.indexOf(".jpg") > -1 ||
        file.indexOf(".jpeg") > -1 ||
        file.indexOf(".png") > -1
      ) {
        mediatype = "image/png";
      } else if (file.indexOf(".pdf") > -1) {
        mediatype = "application/pdf";
      } else if (file.indexOf(".doc") > -1) {
        mediatype = "application/msword";
      } else if (file.indexOf(".docx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (file.indexOf(".gz") > -1) {
        mediatype = "application/gzip";
      } else if (file.indexOf(".rar") > -1) {
        mediatype = "application/vnd.rar";
      } else if (file.indexOf(".tar") > -1) {
        mediatype = "application/x-tar";
      } else if (file.indexOf(".ppt") > -1) {
        mediatype = "application/vnd.ms-powerpoint";
      } else if (file.indexOf(".pptx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      } else if (file.indexOf(".vsd") > -1) {
        mediatype = "application/vnd.visio";
      } else if (file.indexOf(".zip") > -1) {
        mediatype = "application/zip";
      }

      if (mediatype != "") {
        return b64toBlob(data, mediatype); //'data:' + mediatype + ';base64,';
      } else {
        return null;
      }
    },
    expandDiv(arr, ind) {
      $("#modalImg2").modal("show");
      this.$refs.imgzoomC2.onShow(ind, arr);
      /*
            var img = new Image;
            this.modalArr = arr;

            img.onload = () => {
                $('#modalImg2').modal('show');
                this.$refs.imgzoomC.onShow(ind);
            };
            img.src = arr[ind].data;*/
    },
    getListProblems() {
      if (this.dataTask.categories.length < 1) {
        let dataRequest = {
          guid: this.dataTask.equipment[0].guid,
        };
        if (dataRequest.guid != null) {
          this.makeQuery("/service/getListProblemEquipment", {
            dataRequest: dataRequest,
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              for (let i = 0; i < result.length; i++) {
                for (let j = 0; j < this.$store.state.categories.length; j++) {
                  if (
                    parseFloat(result[i].icon) ==
                    this.$store.state.categories[j].id
                  ) {
                    this.dataTask.categories.push({
                      id: this.$store.state.categories[j].id,
                      guid: result[i].guid,
                      title: this.$store.state.categories[j].title,
                      class: this.$store.state.categories[j].class,
                    });
                  }
                }
              }
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
            });
        }
      }
    },
    clickMSPTask() {
      window.open(
        "https://sp.modern-expo.com/crm/task/" + this.dataTask.msp_id
      );
    },
  },
  computed: {
    titleRefr: function () {
      if (this.dataEquipment.refrigerant.name != "") {
        return (
          this.dataEquipment.refrigerant.name +
          " (" +
          this.dataEquipment.refrigerant.weight +
          ")"
        );
      }
    },
    typeTask: function () {
      return this.$t("titles.tasktype." + this.dataTask.WorkType);
    },
  },
  mounted() {},
  watch: {
    "dataTask.tabs.info": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.photo = false;
        this.dataTask.tabs.files = false;
        this.dataTask.tabs.history = false;
      }
    },
    "dataTask.tabs.photo": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.info = false;
        this.dataTask.tabs.files = false;
        this.dataTask.tabs.history = false;

        this.loadPictures();
      }
    },
    "dataTask.tabs.files": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.info = false;
        this.dataTask.tabs.photo = false;
        this.dataTask.tabs.history = false;

        //this.loadInstructions();
      }
    },
    "dataTask.tabs.history": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.info = false;
        this.dataTask.tabs.photo = false;
        this.dataTask.tabs.files = false;

        this.loadHistory();
      }
    },
    "dataTask.tabs.equipm": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.change = false;
      }
    },
    "dataTask.tabs.change": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataTask.tabs.equipm = false;
        //this.getListProblems();
        this.getGPS().then((result) => {
          this.position.latitude = result.latitude;
          this.position.longitude = result.longitude;
          this.position.accuracy = result.accuracy;
          console.log(result);
        });
      }
    },
  },
  created() {
    //this.width = window.innerWidth * 0.8;
    this.width = document.body.clientWidth * 0.9;
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ModalTaskInfo.vue